// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   GOVERNANCE DASHBOARD - PROFESSIONAL STYLING
   ========================================================================== */

/* CSS Variables for Design System */
:root {
  /* Layout */
  --dashboard-max-width: 1250px;
  --container-padding: 24px;
  --grid-gap: 20px;
  --border-radius: 8px;
  
  /* Colors */
  --color-background: #ffffff;
  --color-surface: #ffffff;
  --color-border: #e1e5e9;
  --color-border-light: #f0f0f0;
  
  /* Text Colors */
  --color-text-primary: #1a202c;
  --color-text-secondary: #718096;
  --color-text-muted: #a0aec0;
  
  /* Accent Colors */
  --color-accent: #3182ce;
  --color-success: #38a169;
  --color-error: #e53e3e;
  --color-warning: #d69e2e;
  
  /* Interactive States */
  --color-hover: #f8f9fa;
  --color-active: #e2e8f0;
  
  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  
  /* Typography */
  --font-family-base: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  --font-family-mono: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  
  /* Font Sizes */
  --font-size-xs: 12px;
  --font-size-sm: 13px;
  --font-size-base: 14px;
  --font-size-lg: 16px;
  --font-size-xl: 18px;
  --font-size-2xl: 24px;
  
  /* Font Weights */
  --font-weight-normal: 100;
  --font-weight-medium: 200;
  --font-weight-semibold: 200;
  --font-weight-bold: 400;
  
  /* Transitions */
  --transition-fast: 0.15s ease;
  --transition-base: 0.2s ease;
  --transition-slow: 0.3s ease;
}

/* ==========================================================================
   BASE STYLES & LAYOUT
   ========================================================================== */

/* Override default browser bold styles */
b, strong, th, h1, h2, h3, h4, h5, h6 {
  font-weight: var(--font-weight-medium) !important;
}

/* Main container */
.governance-dashboard {
  width: 100%;
  max-width: var(--dashboard-max-width);
  margin: 0 auto;
  padding: var(--container-padding);
  background-color: var(--color-background);
  min-height: 100vh;
  font-family: var(--font-family-base);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Title */
.governance-dashboard .dashboard-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border);
  width: 100%;
  max-width: 1200px;
}

/* ==========================================================================
   FILTER SECTION
   ========================================================================== */

.governance-dashboard .filter-section {
  display: flex;
  gap: 2rem;
  margin-bottom: 32px;
  align-items: stretch;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
}

.governance-dashboard .search-bar {
  flex: 1 1;
  min-width: 300px;
  max-width: calc(100% - 320px);
  display: flex;
  align-items: center;
}

.governance-dashboard .search-input {
  width: 100%;
  padding: 12px 16px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all var(--transition-fast);
}

.governance-dashboard .search-input:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 1px var(--color-accent);
}

.governance-dashboard .forum-filter {
  position: relative;
  width: 300px;
}

.governance-dashboard .forum-select-header {
  width: 100%;
  padding: 12px 16px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  transition: all var(--transition-fast);
  box-sizing: border-box;
}

.governance-dashboard .forum-select-header:hover {
  border-color: var(--color-accent);
  background: var(--color-hover);
}

.governance-dashboard .dropdown-arrow {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.governance-dashboard .forum-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  margin-top: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: var(--shadow-md);
  padding: 4px 0;
}

.governance-dashboard .forum-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  transition: background-color var(--transition-fast);
}

.governance-dashboard .forum-option:hover {
  background: var(--color-hover);
}

.governance-dashboard .forum-option input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid var(--color-border);
  border-radius: 2px;
  margin: 0;
  cursor: pointer;
  background: var(--color-surface);
  transition: all var(--transition-fast);
}

.governance-dashboard .forum-option input[type="checkbox"]:checked {
  background: var(--color-accent);
  border-color: var(--color-accent);
}

.governance-dashboard .forum-option input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ==========================================================================
   TABLE CONTAINER & STYLING
   ========================================================================== */

.governance-dashboard .governance-table-container {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-bottom: 32px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  transition: box-shadow var(--transition-base);
}

.governance-dashboard .governance-table-container:hover {
  box-shadow: var(--shadow-md);
}

.governance-dashboard .governance-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-sm);
  background: var(--color-surface);
}

.governance-dashboard .governance-table thead {
  position: sticky;
  top: 0;
  background: var(--color-surface);
  z-index: 10;
}

.governance-dashboard .governance-table thead th {
  background: #f5f7fa;
  color: var(--color-text-primary);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium) !important;
  padding: 16px;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
  cursor: pointer;
  transition: background-color var(--transition-fast);
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.governance-dashboard .governance-table thead th.sortable:hover {
  background: #edf2f7;
}

.governance-dashboard .governance-table tbody td {
  padding: 16px;
  vertical-align: middle;
  border-bottom: 1px solid var(--color-border-light);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  transition: background-color var(--transition-fast);
  min-height: 48px;
}

.governance-dashboard .governance-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}

.governance-dashboard .governance-table tbody tr:hover {
  background: var(--color-hover);
}

.governance-dashboard .governance-table tbody tr:last-child td {
  border-bottom: none;
}

/* Forum cell styling */
.governance-dashboard .forum-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.governance-dashboard .forum-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  border-radius: 50%;
}

.governance-dashboard .logo-placeholder {
  width: 24px;
  height: 24px;
  background: var(--color-border-light);
  border-radius: 50%;
}

/* Link styling */
.governance-dashboard .governance-table td a {
  color: var(--color-text-primary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.governance-dashboard .governance-table td a:hover {
  color: var(--color-text-primary);
  text-decoration: underline;
}

/* Sort indicators */
.governance-dashboard .sort-indicator {
  margin-left: 8px;
  font-size: var(--font-size-xs);
  color: var(--color-accent);
}

/* ==========================================================================
   EXPANDABLE PROPOSAL CONTENT
   ========================================================================== */

.governance-dashboard .proposal-row {
  cursor: pointer;
  transition: background-color var(--transition-base);
}

.governance-dashboard .proposal-row:hover {
  background: rgba(0, 0, 0, 0.03);
}

.governance-dashboard .proposal-row.expanded {
  background: rgba(0, 0, 0, 0.02);
}

.governance-dashboard .proposal-content-row {
  background: rgba(0, 0, 0, 0.01);
}

.governance-dashboard .proposal-content {
  padding: 24px;
  border-top: 1px solid var(--color-border-light);
  background: var(--color-surface);
}

.governance-dashboard .proposal-body {
  margin-bottom: 16px;
  line-height: 1.6;
  white-space: pre-wrap;
  font-family: var(--font-family-base);
  color: var(--color-text-primary);
}

.governance-dashboard .proposal-metadata {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  padding-top: 16px;
  border-top: 1px solid var(--color-border-light);
}

.governance-dashboard .source-type {
  text-transform: capitalize;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
}

.governance-dashboard .view-more-link {
  color: var(--color-accent);
  text-decoration: none;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-fast);
}

.governance-dashboard .view-more-link:hover {
  color: var(--color-text-primary);
  text-decoration: underline;
}

/* ==========================================================================
   PAGINATION
   ========================================================================== */

.governance-dashboard .pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding: 16px;
  font-family: var(--font-family-base);
}

.governance-dashboard .pagination-button {
  padding: 12px 20px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.governance-dashboard .pagination-button:hover:not(:disabled) {
  background: var(--color-hover);
  border-color: var(--color-accent);
}

.governance-dashboard .pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: var(--color-text-muted);
}

.governance-dashboard .page-info {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
}

/* ==========================================================================
   LOADING & ERROR STATES
   ========================================================================== */

.governance-dashboard .loading,
.governance-dashboard .error {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: var(--font-size-lg);
  font-family: var(--font-family-base);
}

.governance-dashboard .loading {
  color: var(--color-text-secondary);
}

.governance-dashboard .error {
  color: var(--color-error);
  font-weight: var(--font-weight-medium);
}

/* ==========================================================================
   RESPONSIVE DESIGN
   ========================================================================== */

@media (max-width: 1200px) {
  .governance-dashboard .governance-table-container {
    overflow-x: auto;
  }
}

@media (max-width: 768px) {
  :root {
    --container-padding: 16px;
    --grid-gap: 16px;
  }
  
  .governance-dashboard {
    padding: 16px;
  }
  
  .governance-dashboard .dashboard-title {
    font-size: var(--font-size-xl);
    margin-bottom: 24px;
  }
  
  .governance-dashboard .filter-section {
    flex-direction: column;
    gap: 16px;
  }

  .governance-dashboard .search-bar,
  .governance-dashboard .forum-filter {
    width: 100%;
    max-width: 100%;
  }
  
  .governance-dashboard .governance-table thead th,
  .governance-dashboard .governance-table tbody td {
    padding: 12px 8px;
    font-size: var(--font-size-xs);
  }
  
  .governance-dashboard .proposal-content {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .governance-dashboard .governance-table thead th,
  .governance-dashboard .governance-table tbody td {
    padding: 8px 4px;
  }
  
  .governance-dashboard .forum-cell {
    gap: 8px;
  }
  
  .governance-dashboard .forum-logo,
  .governance-dashboard .logo-placeholder {
    width: 20px;
    height: 20px;
  }
}

/* ==========================================================================
   UTILITY CLASSES
   ========================================================================== */

.governance-dashboard .text-center {
  text-align: center;
}

.governance-dashboard .text-right {
  text-align: right;
}

.governance-dashboard .text-left {
  text-align: left;
}

.governance-dashboard .font-mono {
  font-family: var(--font-family-mono);
}

.governance-dashboard .font-medium {
  font-weight: var(--font-weight-medium);
}

.governance-dashboard .font-semibold {
  font-weight: var(--font-weight-semibold);
}

.governance-dashboard .text-muted {
  color: var(--color-text-muted);
}

.governance-dashboard .text-secondary {
  color: var(--color-text-secondary);
} `, "",{"version":3,"sources":["webpack://./src/styles/governance_dashboard.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E,oCAAoC;AACpC;EACE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;;EAEpB,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;;EAE7B,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;;EAE3B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;;EAExB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;;EAEvB,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;;EAE3C,eAAe;EACf,wHAAwH;EACxH,wHAAwH;;EAExH,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;;EAErB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E,yCAAyC;AACzC;EACE,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,iCAAiC;EACjC,yCAAyC;EACzC,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;AACnB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;EAChC,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,iDAAiD;EACjD,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;EACf,mDAAmD;EACnD,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,oCAAoC;EACpC,8BAA8B;EAC9B,gCAAgC;EAChC,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,oCAAoC;EACpC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;+EAE+E;;AAE/E;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* ==========================================================================\n   GOVERNANCE DASHBOARD - PROFESSIONAL STYLING\n   ========================================================================== */\n\n/* CSS Variables for Design System */\n:root {\n  /* Layout */\n  --dashboard-max-width: 1250px;\n  --container-padding: 24px;\n  --grid-gap: 20px;\n  --border-radius: 8px;\n  \n  /* Colors */\n  --color-background: #ffffff;\n  --color-surface: #ffffff;\n  --color-border: #e1e5e9;\n  --color-border-light: #f0f0f0;\n  \n  /* Text Colors */\n  --color-text-primary: #1a202c;\n  --color-text-secondary: #718096;\n  --color-text-muted: #a0aec0;\n  \n  /* Accent Colors */\n  --color-accent: #3182ce;\n  --color-success: #38a169;\n  --color-error: #e53e3e;\n  --color-warning: #d69e2e;\n  \n  /* Interactive States */\n  --color-hover: #f8f9fa;\n  --color-active: #e2e8f0;\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);\n  --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  \n  /* Typography */\n  --font-family-base: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  --font-family-mono: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  \n  /* Font Sizes */\n  --font-size-xs: 12px;\n  --font-size-sm: 13px;\n  --font-size-base: 14px;\n  --font-size-lg: 16px;\n  --font-size-xl: 18px;\n  --font-size-2xl: 24px;\n  \n  /* Font Weights */\n  --font-weight-normal: 100;\n  --font-weight-medium: 200;\n  --font-weight-semibold: 200;\n  --font-weight-bold: 400;\n  \n  /* Transitions */\n  --transition-fast: 0.15s ease;\n  --transition-base: 0.2s ease;\n  --transition-slow: 0.3s ease;\n}\n\n/* ==========================================================================\n   BASE STYLES & LAYOUT\n   ========================================================================== */\n\n/* Override default browser bold styles */\nb, strong, th, h1, h2, h3, h4, h5, h6 {\n  font-weight: var(--font-weight-medium) !important;\n}\n\n/* Main container */\n.governance-dashboard {\n  width: 100%;\n  max-width: var(--dashboard-max-width);\n  margin: 0 auto;\n  padding: var(--container-padding);\n  background-color: var(--color-background);\n  min-height: 100vh;\n  font-family: var(--font-family-base);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Title */\n.governance-dashboard .dashboard-title {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--color-border);\n  width: 100%;\n  max-width: 1200px;\n}\n\n/* ==========================================================================\n   FILTER SECTION\n   ========================================================================== */\n\n.governance-dashboard .filter-section {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 32px;\n  align-items: stretch;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.governance-dashboard .search-bar {\n  flex: 1;\n  min-width: 300px;\n  max-width: calc(100% - 320px);\n  display: flex;\n  align-items: center;\n}\n\n.governance-dashboard .search-input {\n  width: 100%;\n  padding: 12px 16px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius);\n  box-sizing: border-box;\n  transition: all var(--transition-fast);\n}\n\n.governance-dashboard .search-input:focus {\n  outline: none;\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 1px var(--color-accent);\n}\n\n.governance-dashboard .forum-filter {\n  position: relative;\n  width: 300px;\n}\n\n.governance-dashboard .forum-select-header {\n  width: 100%;\n  padding: 12px 16px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  user-select: none;\n  transition: all var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.governance-dashboard .forum-select-header:hover {\n  border-color: var(--color-accent);\n  background: var(--color-hover);\n}\n\n.governance-dashboard .dropdown-arrow {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.governance-dashboard .forum-dropdown-content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius);\n  margin-top: 4px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: var(--shadow-md);\n  padding: 4px 0;\n}\n\n.governance-dashboard .forum-option {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  user-select: none;\n  gap: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  transition: background-color var(--transition-fast);\n}\n\n.governance-dashboard .forum-option:hover {\n  background: var(--color-hover);\n}\n\n.governance-dashboard .forum-option input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--color-border);\n  border-radius: 2px;\n  margin: 0;\n  cursor: pointer;\n  background: var(--color-surface);\n  transition: all var(--transition-fast);\n}\n\n.governance-dashboard .forum-option input[type=\"checkbox\"]:checked {\n  background: var(--color-accent);\n  border-color: var(--color-accent);\n}\n\n.governance-dashboard .forum-option input[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ==========================================================================\n   TABLE CONTAINER & STYLING\n   ========================================================================== */\n\n.governance-dashboard .governance-table-container {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  margin-bottom: 32px;\n  width: 100%;\n  max-width: 1200px;\n  box-sizing: border-box;\n  transition: box-shadow var(--transition-base);\n}\n\n.governance-dashboard .governance-table-container:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.governance-dashboard .governance-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--font-size-sm);\n  background: var(--color-surface);\n}\n\n.governance-dashboard .governance-table thead {\n  position: sticky;\n  top: 0;\n  background: var(--color-surface);\n  z-index: 10;\n}\n\n.governance-dashboard .governance-table thead th {\n  background: #f5f7fa;\n  color: var(--color-text-primary);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium) !important;\n  padding: 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.governance-dashboard .governance-table thead th.sortable:hover {\n  background: #edf2f7;\n}\n\n.governance-dashboard .governance-table tbody td {\n  padding: 16px;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--color-border-light);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  transition: background-color var(--transition-fast);\n  min-height: 48px;\n}\n\n.governance-dashboard .governance-table tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n.governance-dashboard .governance-table tbody tr:hover {\n  background: var(--color-hover);\n}\n\n.governance-dashboard .governance-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Forum cell styling */\n.governance-dashboard .forum-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.governance-dashboard .forum-logo {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n  border-radius: 50%;\n}\n\n.governance-dashboard .logo-placeholder {\n  width: 24px;\n  height: 24px;\n  background: var(--color-border-light);\n  border-radius: 50%;\n}\n\n/* Link styling */\n.governance-dashboard .governance-table td a {\n  color: var(--color-text-primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\n.governance-dashboard .governance-table td a:hover {\n  color: var(--color-text-primary);\n  text-decoration: underline;\n}\n\n/* Sort indicators */\n.governance-dashboard .sort-indicator {\n  margin-left: 8px;\n  font-size: var(--font-size-xs);\n  color: var(--color-accent);\n}\n\n/* ==========================================================================\n   EXPANDABLE PROPOSAL CONTENT\n   ========================================================================== */\n\n.governance-dashboard .proposal-row {\n  cursor: pointer;\n  transition: background-color var(--transition-base);\n}\n\n.governance-dashboard .proposal-row:hover {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.governance-dashboard .proposal-row.expanded {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.governance-dashboard .proposal-content-row {\n  background: rgba(0, 0, 0, 0.01);\n}\n\n.governance-dashboard .proposal-content {\n  padding: 24px;\n  border-top: 1px solid var(--color-border-light);\n  background: var(--color-surface);\n}\n\n.governance-dashboard .proposal-body {\n  margin-bottom: 16px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  font-family: var(--font-family-base);\n  color: var(--color-text-primary);\n}\n\n.governance-dashboard .proposal-metadata {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  padding-top: 16px;\n  border-top: 1px solid var(--color-border-light);\n}\n\n.governance-dashboard .source-type {\n  text-transform: capitalize;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n}\n\n.governance-dashboard .view-more-link {\n  color: var(--color-accent);\n  text-decoration: none;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n  transition: color var(--transition-fast);\n}\n\n.governance-dashboard .view-more-link:hover {\n  color: var(--color-text-primary);\n  text-decoration: underline;\n}\n\n/* ==========================================================================\n   PAGINATION\n   ========================================================================== */\n\n.governance-dashboard .pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 24px;\n  padding: 16px;\n  font-family: var(--font-family-base);\n}\n\n.governance-dashboard .pagination-button {\n  padding: 12px 20px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text-primary);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.governance-dashboard .pagination-button:hover:not(:disabled) {\n  background: var(--color-hover);\n  border-color: var(--color-accent);\n}\n\n.governance-dashboard .pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  color: var(--color-text-muted);\n}\n\n.governance-dashboard .page-info {\n  font-size: var(--font-size-base);\n  color: var(--color-text-secondary);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ==========================================================================\n   LOADING & ERROR STATES\n   ========================================================================== */\n\n.governance-dashboard .loading,\n.governance-dashboard .error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-size: var(--font-size-lg);\n  font-family: var(--font-family-base);\n}\n\n.governance-dashboard .loading {\n  color: var(--color-text-secondary);\n}\n\n.governance-dashboard .error {\n  color: var(--color-error);\n  font-weight: var(--font-weight-medium);\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN\n   ========================================================================== */\n\n@media (max-width: 1200px) {\n  .governance-dashboard .governance-table-container {\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  :root {\n    --container-padding: 16px;\n    --grid-gap: 16px;\n  }\n  \n  .governance-dashboard {\n    padding: 16px;\n  }\n  \n  .governance-dashboard .dashboard-title {\n    font-size: var(--font-size-xl);\n    margin-bottom: 24px;\n  }\n  \n  .governance-dashboard .filter-section {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .governance-dashboard .search-bar,\n  .governance-dashboard .forum-filter {\n    width: 100%;\n    max-width: 100%;\n  }\n  \n  .governance-dashboard .governance-table thead th,\n  .governance-dashboard .governance-table tbody td {\n    padding: 12px 8px;\n    font-size: var(--font-size-xs);\n  }\n  \n  .governance-dashboard .proposal-content {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .governance-dashboard .governance-table thead th,\n  .governance-dashboard .governance-table tbody td {\n    padding: 8px 4px;\n  }\n  \n  .governance-dashboard .forum-cell {\n    gap: 8px;\n  }\n  \n  .governance-dashboard .forum-logo,\n  .governance-dashboard .logo-placeholder {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* ==========================================================================\n   UTILITY CLASSES\n   ========================================================================== */\n\n.governance-dashboard .text-center {\n  text-align: center;\n}\n\n.governance-dashboard .text-right {\n  text-align: right;\n}\n\n.governance-dashboard .text-left {\n  text-align: left;\n}\n\n.governance-dashboard .font-mono {\n  font-family: var(--font-family-mono);\n}\n\n.governance-dashboard .font-medium {\n  font-weight: var(--font-weight-medium);\n}\n\n.governance-dashboard .font-semibold {\n  font-weight: var(--font-weight-semibold);\n}\n\n.governance-dashboard .text-muted {\n  color: var(--color-text-muted);\n}\n\n.governance-dashboard .text-secondary {\n  color: var(--color-text-secondary);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
